import styled, { css } from 'styled-components';
import colors from '../../../../helpers/colors';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { TertiaryButton } from '../../../Button';
import { GridItem } from '../../../Grid';
import LogoLink from '../../../LogoLink';
import { desktopHeaderHeight } from '../../Header/styles';
import SecondaryNavMenu from '../../NavDesktop/SecondaryNavDesktop/SecondaryNavMenu';

export const HeaderInner = styled.div`
  display: none;

  ${mediaQuery.tabletLandscape`
    display: flex;
    margin: 0 auto;
    justify-content: flex-start;
    align-items: center;
    padding: ${spacing(1)} 0;
    background-color: ${colors.neutral08};
  `}
`;

export const StyledGridItem = styled(GridItem)`
  display: flex;
  align-items: center;
`;

export const RightAlignedGridItem = styled(GridItem)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Logo = styled(LogoLink)`
  display: flex;
  align-items: center;

  img {
    height: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
      height: ${spacing(3.5)};
    `}
  }
`;

export const CtaContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const buttonStyling = css`
  text-decoration: none;
  padding: ${spacing(1.5)} ${spacing(2.5)};
  height: auto;
  text-align: center;
`;

export const StyledTertiaryButtonWithMargin = styled(TertiaryButton)`
  ${buttonStyling};
  border: ${colors.core01} solid 1px;
`;

export const SecondaryMenu = styled.div`
  display: none;

  position: absolute;
  top: calc(100% + ${spacing(1)});
  right: 0;
  width: 240px;

  background: ${colors.core02};
  border-radius: 0 0 8px 8px;

  ${mediaQuery.tabletLandscape`
    display: block;
  `}

  ${mediaQuery.desktop`
    width: 290px;
  `}

  h3, li {
    & {
      color: ${colors.neutral08};
    }
  }

  h3 {
    margin-bottom: ${spacing(4)};
  }

  li {
    margin: ${spacing(3)} 0;
  }
`;

export const StyledSecondaryNavMenu = styled(SecondaryNavMenu)`
  padding-top: calc(${desktopHeaderHeight} + ${spacing(4)});
`;

export const NavItemWrapper = styled.div`
  display: flex;
  position: relative;
  margin-left: ${spacing(3)};

  :first-of-type {
    margin-left: 0;
  }
`;
